import { put, takeEvery } from 'redux-saga/effects';
import { DONE_REQUEST } from '../actionConstants/sequentialModals';
import { doneSuccessSequentialModal } from '../actions';

function* setDoneRequestHandler(action) {
  const {
    payload: { modalId },
  } = action;
  yield put(doneSuccessSequentialModal({ modalId }));
}

export default function* sequentialModalsSaga() {
  yield takeEvery(DONE_REQUEST, setDoneRequestHandler);
}
